import styled from "styled-components"
import SquadMakerHeaderItem from "./SquadMakerHeaderItem"
import SynergyDisplay from "./SynergyDisplay"
import { useSquad } from "../contexts/SquadContext"
import { calculateSetDeckPoint } from "../utils/calculateSetDeckPoint"
import { calculateBatterPlayerOvr, calculatePitcherPlayerOvr, calculateTotalPlayerOvr } from "../utils/calculatePlayerOvr"
import { SelectPopup } from "./SelectPopup"
import { useState } from "react"
import { getSynergyTexts } from "../utils/calculateSynergyStates"

const StyledHeader = styled.div`
    display: flex;
    flex-direction: row;
    padding: 2rem 3rem;
    justify-content: space-between;
`
const HorizontalLineThick = styled.div`
    height: 0.625rem;
    width: 100%;
    background-color: #545454;
`

const HorizontalLineThin = styled.div`
    height: 0.125rem;
    width: 100%;
    background-color: #545454;
`

const PopupContainer = styled.div`
    width: 0rem;
    position: absolute;
    overflow: visible;
    z-index: 10;
`

export default function SquadMakerHeader({ onSetDeckClick }) {

    const { playerInfos, addPlayer, setProperty, removePlayer } = useSquad();

    const setDeckPoint = calculateSetDeckPoint(playerInfos);
    const totalOvr = calculateTotalPlayerOvr(playerInfos);
    const batterOvr = calculateBatterPlayerOvr(playerInfos);
    const pitcherOvr = calculatePitcherPlayerOvr(playerInfos);

    const [isTeamSelectPopupVisible, setIsTeamSelectPopupVisible] = useState(false);
    const [isLineupSelectPopupVisible, setIsLineupSelectPopupVisible] = useState(false);
    const teamItems = ["두산", "LG", "KIA", "삼성", "SSG", "한화", "롯데", "KT", "NC", '키움'];
    const lineupItems = ["랭킹 챌린지", "실시간 매치", "클럽 대전", "리그 모드", "스폐셜 매치"];
    const synergyDisplays = getSynergyTexts(playerInfos);

    return (
        <div>
            <HorizontalLineThick/>
            <StyledHeader>
                <SquadMakerHeaderItem
                    isNumber={true}
                    label={"총 세트덱 포인트"}
                    content={setDeckPoint}
                    onClick={onSetDeckClick}
                />

                <SquadMakerHeaderItem
                    isNumber={true}
                    label={"총 OVR"}
                    content={totalOvr}
                />

                
                <SquadMakerHeaderItem
                    isNumber={true}
                    label={"타자 OVR  /  투수 OVR"}
                    content={`${batterOvr} / ${pitcherOvr}`}
                />

                <div style={{ position: "relative" }}>
                    <SquadMakerHeaderItem
                        isNumber={false}
                        label={"선호 구단"}
                        content={playerInfos.selectedTeam || "없음"}
                        onClick={() => {setIsTeamSelectPopupVisible(true)}}
                    />

                    <PopupContainer>
                        <SelectPopup
                            isVisible={isTeamSelectPopupVisible}
                            gridCols={3}
                            onClose={() => {setIsTeamSelectPopupVisible(false)}}
                            onSelect={(team) => {
                                setProperty("selectedTeam", team);
                                setIsTeamSelectPopupVisible(false);
                            }}
                            initialValue={playerInfos.selectedTeam}
                            items={teamItems}
                        />
                    </PopupContainer>
                </div>

                <div style={{ position: "relative" }}>

                    <SquadMakerHeaderItem
                        isNumber={false}
                        label={"선택 라인업"}
                        content={playerInfos.selectedLineup || "없음"}
                        onClick={() => {setIsLineupSelectPopupVisible(true)}}
                    />

                    <PopupContainer>
                        <SelectPopup
                            isVisible={isLineupSelectPopupVisible}
                            gridCols={1}
                            onClose={() => {setIsLineupSelectPopupVisible(false)}}
                            onSelect={(lineup) => {
                                setProperty("selectedLineup", lineup);
                                setIsLineupSelectPopupVisible(false);
                            }}
                            initialValue={playerInfos.selectedLineup}
                            items={lineupItems}
                        />
                    </PopupContainer>

                </div>

                <SynergyDisplay
                    synergies={ synergyDisplays
                        // [
                        //     {condition: "라이브, 시즌, 국가대표, 올스타 3장 이상", currentNumber: 5, targetNumber: 3, result: '모든 선수 능력치 +1', isPositive: true },
                        //     {condition: "임팩트 7장 이상", currentNumber: 6, targetNumber: 7, result: '없음', isPositive: false },
                        //     {condition: "시그니쳐 6장 이상", currentNumber: 7, targetNumber: 6, result: '모든 투수 모든 능력치 +1', isPositive: true },
                        //     {condition: "골든글러브, 올스타 4장 이하", currentNumber: 4, targetNumber: 3, result: '없음', isPositive: true }
                        // ]
                    }
                />

            </StyledHeader>
            <HorizontalLineThin/>
        </div>
    )
}